module.exports = __webpack_public_path__ + "img/scene_cool_white_big@2x.57d21c24.png";